import React, { Component } from 'react'
import MyApi from '../../api/MyApi'

class AboutMain extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sta: '1',
      status: false,
      message: "",
      recruitData: [],
      recruitData2: []
    }
  }

  initData() {
    {
      let res = {"message":"请求数据成功","c_recruit":[{"contents":"システムエンジニア（PM・SE・PG、WEB系・汎用機系など） 国籍問わずに外国籍の方は日本語が流暢","id":"1","contTitle":"募集職種："},{"contents":"数名","id":"2","contTitle":"採用人数："},{"contents":"正社員、契約社員（試用期間があります）","id":"3","contTitle":"雇用形態："},{"contents":"システムに関する業務|• 提案書作成、見積作成、お客様との交渉|• システム設計、開発、テスト、導入|• システムの運用、保守など","id":"4","contTitle":"仕事内容："},{"contents":"何らかの開発知識ある方|※情報処理系、理工系学部・学校出身者なら実務未経験でも歓迎！|【こんな方を歓迎します！】|☆ Java、.NET経験者|☆ ITの基本知識を活かしてエンジニアとしてキャリアアップしたい方|☆ PGからSE、SEからリーダーへステップアップを目指す方|☆ 上流工程を経験したい方|☆ 大規模プロジェクトに挑戦したい方","id":"5","contTitle":"求める人材："},{"contents":"25万～60万円|• 経験、能力を考慮し、当社規定により優遇します。|• 面接にてお会いの上、確定させていただきます。","id":"6","contTitle":"待遇："},{"contents":"年1回（4月）","id":"7","contTitle":"昇給："},{"contents":"リーダー手当、残業手当、通勤手当（上限3万円/月まで）","id":"8","contTitle":"諸手当："},{"contents":"週休2日制（土・日）祝日、有給休暇、年末年始休暇","id":"9","contTitle":"休日•休暇："},{"contents":"社会保険完備、健康保険組合の保養所・レジャー施設利用可、各種イベント","id":"10","contTitle":"福利厚生："},{"contents":"当社、一都三県 海外業務の展開次第、海外出張あるいは常駐","id":"11","contTitle":"勤務地："},{"contents":"9:00～18:00（プロジェクトにより若干異なる）","id":"12","contTitle":"就業時間："}],"status":true}
      res.contentArr = res.c_recruit
      delete res.c_recruit
      let recruitData = [];
      recruitData[0] = {contentArr:res.contentArr}
      this.setState({"recruitData":recruitData})
    }
    {
      let res = {"c_recruit2":[{"contents":"|• SUN FLOWER SOFT 株式会社では、顧客満足度向上のため協力会社様を募集しております。ぜひ御社のお力をお貸しください。|• ご協力いただける企業様につきましては、電話または問い合わせフォームよりご連絡くださいますようお願い申し上げます。","id":"1","contTitle":"協力会社様募集"},{"contents":"特に求めるご協力会社様|• 安定した協力社員を提供し、できるだけ当社の営業を手配することができます。|• 誠実に信用を守り、法律の許す範囲内で契約を守らなければならない。","id":"2","contTitle":"募集内容："},{"contents":"|【こんな方を歓迎します！】|☆ Java、.NET、C、Salseforce経験者|☆ 日本語はN 2以上です|☆ ITの基本知識を活かしてエンジニアとしてキャリアアップしたい方|☆ PGからSE、SEからリーダーへステップアップを目指す方|☆ 上流工程を経験したい方|☆ 大規模プロジェクトに挑戦したい方|☆ 面接にてお会いの上、確定させていただきます。","id":"3","contTitle":"協力社員の要求"},{"contents":"9:00～18:00（プロジェクトにより若干異なる）|具体的な協力方式と詳細は私達と連絡してください。","id":"4","contTitle":"就業時間："},{"contents":"|03-3525-8872","id":"5","contTitle":"電話番号"},{"contents":"|info@sunflower-soft.com","id":"6","contTitle":"メール"}],"message":"请求数据成功","status":true}
      res.contentArr2 = res.c_recruit2
      delete res.c_recruit2
      let recruitData2 = [];
      recruitData2[0] = {contentArr:res.contentArr2}
      this.setState({"recruitData2":recruitData2})
    }
    // MyApi.queryAllApi('post','queryAllApi','c_recruit').then((res) => {
    //   res.contentArr = res.c_recruit
    //   delete res.c_recruit
    //   let recruitData = [];
    //   recruitData[0] = {contentArr:res.contentArr}
    //   this.setState({"recruitData":recruitData})
    // })
    // MyApi.queryAllApi('post','queryAllApi','c_recruit2').then((res) => {
    //   res.contentArr2 = res.c_recruit2
    //   delete res.c_recruit2
    //   let recruitData2 = [];
    //   recruitData2[0] = {contentArr:res.contentArr2}
    //   this.setState({"recruitData2":recruitData2})
    // })
  }

  componentDidMount() {
    this.initData()
  }
  render() {

    //社員採用
    let recruitList = this.state.recruitData.map((recruit) => {
      let recruitList = recruit.contentArr.map((cont) => {
        let contenA = cont.contents.split('|');
        let num = 0;
        const content = contenA.map((content,key) => {
          if (contenA[0] === content) {
            return <span key={key}><strong className="stitle">{cont.contTitle}</strong>{content}</span>
          } else {
            num++;
            return <p key={num} style={{paddingLeft:30}}>{content}</p>
          }
        })

        return (<li key={cont.id}>{content}</li>)
      })
      return (
        <div className="content" key={1}>
          <ol key="recruit.id">
            {recruitList}
          </ol>
        </div>
      )
    })
    
    //寻求合作
    let recruitList2 = this.state.recruitData2.map((recruit) => {
      let recruitList2 = recruit.contentArr.map((cont) => {
        let contenA = cont.contents.split('|');
        let num = 0;
        const content = contenA.map((content,key) => {
          if (contenA[0] === content) {
            return <span key={key}><strong className="stitle">{cont.contTitle}</strong>{content}</span>
          } else {
            num++;
            return <p key={num} style={{paddingLeft:30}}>{content}</p>
          }
        })

        return (<li key={cont.id}>{content}</li>)
      })
      return (
        <div className="content" key={1}>
          <ol key="recruit.id">
            {recruitList2}
          </ol>
        </div>
      )
    })


    let page
    if (this.state.sta === '1') {
      page = <div className="layui-row">
        <ul className="aboutab">
          <li className="layui-this">社員採用</li><li onClick={() => this.setState({ sta: '2' })}>協力会社</li>
        </ul>

        {/* 社員採用 */}
        <div className="tabJob">
          {recruitList}
        </div>
      </div>
    }

    if (this.state.sta === '2') {
      page = <div className="layui-row">
        <ul className="aboutab">
          <li onClick={() => this.setState({ sta: '1' })}>社員採用</li><li className="layui-this">協力会社</li>
        </ul>

        {/* 協力会社 */}
        <div className="tabJob">
          {recruitList2}
        </div>
      </div>
    }

    return (
      <div className="main-about" >
        <div className="layui-container">
          {page}
        </div>
      </div>
    )
  }
}

export default AboutMain